// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "5b2a8d50" + ".chunk.css";
};